import { render, staticRenderFns } from "./MobileLandingRecoveryComponent.vue?vue&type=template&id=0b43e77e"
import script from "./MobileLandingRecoveryComponent.vue?vue&type=script&lang=js"
export * from "./MobileLandingRecoveryComponent.vue?vue&type=script&lang=js"
import style0 from "./MobileLandingRecoveryComponent.vue?vue&type=style&index=0&id=0b43e77e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports